"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var color_1 = require("../utilities/color");
var message_button_1 = __importDefault(require("./message-button"));
var stack_container_1 = __importStar(require("./stack-container"));
var i18next_1 = __importDefault(require("i18next"));
var ReactionRow = /** @class */ (function (_super) {
    __extends(ReactionRow, _super);
    function ReactionRow(textures, minWidth) {
        var _this = _super.call(this) || this;
        _this._textures = textures;
        _this._minWidth = minWidth;
        _this.addChild(_this.stackContainer);
        return _this;
    }
    Object.defineProperty(ReactionRow.prototype, "nameLabel", {
        get: function () {
            if (!this._nameLabel) {
                this._nameLabel = new PIXI.Text("");
                this._nameLabel.style = {
                    fontFamily: "Arial",
                    fontSize: 19,
                    fill: color_1.COLOR.WHITE
                };
            }
            return this._nameLabel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ReactionRow.prototype, "dateLabel", {
        get: function () {
            if (!this._dateLabel) {
                this._dateLabel = new PIXI.Text("");
                this._dateLabel.style = {
                    fontFamily: "Arial",
                    fontSize: 15,
                    fill: color_1.COLOR.GREEN
                };
            }
            return this._dateLabel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ReactionRow.prototype, "headerContainer", {
        get: function () {
            if (!this._headerContainer) {
                this._headerContainer = new stack_container_1.default([
                    this.nameLabel,
                    this.dateLabel
                ], {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.HORIZONTAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: 12
                });
            }
            return this._headerContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ReactionRow.prototype, "messageButton", {
        get: function () {
            if (!this._messageButton) {
                this._messageButton = new message_button_1.default(this._textures, null);
            }
            return this._messageButton;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ReactionRow.prototype, "stackContainer", {
        get: function () {
            if (!this._stackContainer) {
                this._stackContainer = new stack_container_1.default([
                    this.headerContainer,
                    this.messageButton
                ], {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.VERTICAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.LEADING,
                    spacing: 10,
                    minWidth: this._minWidth,
                    minHeight: 80
                });
            }
            return this._stackContainer;
        },
        enumerable: false,
        configurable: true
    });
    ReactionRow.prototype.configureAppearance = function (name, message, messageStyle, date) {
        if (name == this._name && message == this._message && messageStyle == this._messageStyle && date == this._date) {
            return;
        }
        this._name = name;
        this._message = message;
        this._messageStyle = messageStyle;
        this._date = date;
        this.nameLabel.text = "  " + ((name === null || name === void 0 ? void 0 : name.trim()) ? name : i18next_1.default.t("name_none"));
        this.messageButton.setText(message, messageStyle);
        this.dateLabel.text = date;
        this.stackContainer.layoutChildren();
    };
    return ReactionRow;
}(PIXI.Container));
exports.default = ReactionRow;
